export default __webpack_public_path__ + "static/media/4_tms_for_hotels.5165b50b.svg";